// extracted by mini-css-extract-plugin
export default {"title":"AcknowledgementAndConsent_title__6CRaB","bodyText":"AcknowledgementAndConsent_bodyText__xXoe-","buttonContainer":"AcknowledgementAndConsent_buttonContainer__MI+yj"};